import React from "react";
import { Link } from "react-router-dom";
function portfolio1() {
  function linkClick() {
    window.open("https://typinggamebyjon.netlify.app", "_blank");
  }

  return (
    <div>
      <section className="intro">
        <h1 className="section__title section__title--intro">
          WPM <strong> Typing Game </strong>
        </h1>
        <p className="section__subtitle section__subtitle--intro">
          How quickly can you type?
        </p>
        <img
          src="/assets/images/portfolio-01.jpg"
          alt="a picture of a laptop"
          className="intro__img"
        />
      </section>

      <div className="portfolio-item-individual">
        <img
          src="/assets/images/WPM GAME.png"
          alt="temp photo change this later"
        />
        <h3 className="portfolio-header">
          A minigame I created that tests users WPM
        </h3>
        <p className="portfolio-paragraph">
          A test for users to see how fast they can type. The hardest part of
          building this app was the timer functionality as I needed to build a
          way for users to set their own time, be stopped when time hits zero,
          and not let them type negative times all at the same time.
        </p>
        <h3 className="portfolio-btn" onClick={linkClick}>
          Play the game by clicking here:
        </h3>
      </div>
    </div>
  );
}

export default portfolio1;
